import { publicImages } from '@utils/shared'
import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  bannerWrapper: {
    backgroundImage: `url(${publicImages.costimizerBannerBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: '3rem',
    borderRadius: '8px',
    backgroundColor: '#7c5fff',
    // maxHeight: '562px',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
    alignSelf: 'center',
    gap: '0.5rem',
  },
  actionButton: {
    marginTop: '2rem !important',
    alignSelf: 'flex-start !important',
    backgroundColor: 'neutral.white',
    color: 'text.primary',
    '&:hover': {
      backgroundColor: 'neutral.white',
      color: 'text.primary',
    },
    '& .MuiSvgIcon-root': {
      color: 'text.primary',
    },
  },
  imgStyle: {
    display: {
      xs: 'none',
      md: 'block',
    },
    width: '550px',
    height: '400px',
    img: {
      width: '100%',
      height: '100%',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
